import React, { ReactNode } from "react"
import { Link as ChakraLink, LinkProps } from "@chakra-ui/react"
import { useHistory } from "react-router-dom"

type LocationDescriptor = string | { pathname: string; state?: unknown }

type Props = {
  children: ReactNode
  to?: LocationDescriptor
  href?: string
  underlined?: boolean
  isDisabled?: boolean
} & LinkProps

const Link = ({
  children, color = "blue.500", textDecoration = "underline", underlined = false, to, href, isDisabled, ...props
}: Props) => {
  const history = useHistory()
  const toPath = typeof to === "object" ? to.pathname : to

  return (
    <ChakraLink
      color={isDisabled ? "gray.400" : color}
      textDecoration={underlined ? "underline" : "none"}
      onClick={to ? (e) => {
        history.push(to)
        e.preventDefault()
      } : undefined}
      href={toPath || href}
      to={isDisabled ? undefined : toPath}
      pointerEvents={isDisabled ? "none" : "auto"}
      _hover={{ textDecoration }}
      {...props}
    >{children}
    </ChakraLink>
  )
}

export default Link
